"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventDisplayFlags = void 0;
const react_1 = require("react");
const useEventDisplayFlags = ({ eventData, localRoundValue, }) => {
    const isSingleRoundEvent = (0, react_1.useMemo)(() => eventData?.rounds?.length === 1, [eventData?.rounds]);
    const isMultiRoundEvent = (0, react_1.useMemo)(() => eventData?.rounds?.length > 1, [eventData?.rounds]);
    const isSingleGrossRound = (0, react_1.useMemo)(() => isSingleRoundEvent && eventData?.rounds?.[0]?.scoreFormat?.toLowerCase() === 'gross', [isSingleRoundEvent, eventData?.rounds]);
    const hasCurrentRoundCourseName = (0, react_1.useMemo)(() => isMultiRoundEvent && !!eventData?.rounds?.[localRoundValue - 1]?.courseName, [isMultiRoundEvent, eventData?.rounds, localRoundValue]);
    const showNetGrossToggle = (0, react_1.useMemo)(() => eventData?.rounds?.length > 0 &&
        localRoundValue > 0 &&
        eventData?.rounds?.[localRoundValue - 1]?.scoreFormat?.toLowerCase() !== 'gross', [eventData?.rounds, localRoundValue]);
    const isIndividualEvent = (0, react_1.useMemo)(() => ['single', 'pair'].includes(eventData?.regType?.toLowerCase() || ''), [eventData?.regType]);
    const hasSkinsGame = (0, react_1.useMemo)(() => eventData?.rounds?.length >= localRoundValue &&
        localRoundValue > 0 &&
        eventData?.rounds?.[localRoundValue - 1]?.sideGames?.some((sideGame) => sideGame.name === 'skins'), [eventData?.rounds, localRoundValue]);
    const hasDivisions = (0, react_1.useMemo)(() => (eventData?.flighting?.divisions?.length ?? 0) > 0, [eventData?.flighting]);
    const hasFlights = (0, react_1.useMemo)(() => (eventData?.flighting?.flights?.length ?? 0) > 0, [eventData?.flighting]);
    return {
        isSingleRoundEvent,
        isMultiRoundEvent,
        isSingleGrossRound,
        hasCurrentRoundCourseName,
        showNetGrossToggle,
        isIndividualEvent,
        hasSkinsGame,
        hasDivisions,
        hasFlights,
    };
};
exports.useEventDisplayFlags = useEventDisplayFlags;
